<!-- /* [NT-APPLY-NAP-P-POP]NAP 자문신청(개인) */ -->

<template>
  <div>
    <BasicModal
      :isShowModal="isModal"
      @close-modal="onClose"
      title="NAP 자문 신청하기"
      disabledFooter
      v-if="data"
    >
      <div class="popupViewProfile">
        <UserInfoCard :data="data" />

        <MatchingProcessItems />

        <section>
          <ValidationObserver v-slot="{ handleSubmit }" class="aRow5">
            <form
              class="infoBoxForm"
              @submit.prevent="handleSubmit(onClickSubmitForm)"
            >
              <h3 class="matchingHeadLine">신청서 작성</h3>
              <div style="margin-bottom: 50px;">
                <InputField label="신청 대상 회원" v-model="data.name" />

                <ValidationProvider
                  name="NAP 자문 요청 사항"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="매칭신청 사유"
                    v-model="form.application"
                    :errors="errors"
                  />
                </ValidationProvider>

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">연락처 정보</h3>
                <InputField label="신청자 이름" v-model="user.name" />
                <InputField label="이메일 주소" v-model="user.email" />
                <InputField label="전화번호" v-model="user.phoneNumber" />

                <div class="line" style="margin-top: 20px;"></div>
                <h3 class="matchingHeadLine">NAP 자문 요청</h3>
                <ValidationProvider
                  name="NAP 자문 요청 사항"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <TextAreaInputField
                    label="NAP 자문 요청 사항"
                    v-model="form.question"
                    :errors="errors"
                  />
                </ValidationProvider>
              </div>

              <div class="modal-action">
                <MainButton
                  btnText="신청서 작성"
                  color="green"
                  type="submit"
                  :disabled="disabledSubmit"
                />
              </div>
            </form>
          </ValidationObserver>
        </section>
      </div>
    </BasicModal>
  </div>
</template>

<script>
import axios from "@/axios/axios";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import MainButton from "@/components/button/MainButton.vue";
import BasicModal from "@/components/modal/BasicModal.vue";
import MatchingProcessItems from "@/components/items/MatchingProcessItems.vue";
import InputField from "@/components/formControl/InputField.vue";
import TextAreaInputField from "@/components/formControl/TextAreaInputField.vue";
import UserInfoCard from "@/components/items/UserInfoCard.vue";

export default {
  name: "PopupNAPConsultationApplication",
  components: {
    BasicModal,
    MainButton,
    MatchingProcessItems,
    ValidationObserver,
    ValidationProvider,
    InputField,
    TextAreaInputField,
    UserInfoCard,
  },
  props: {
    isModal: Boolean,
    handleToggleModal: Function,
    data: Object,
  },
  data() {
    return {
      user: this.$store.state.auth.user,
      disabledSubmit: false,
      form: {
        requesterIdx: this.$store.state.auth.user.idx,
        requestedIdx: 2,
        application: "",
        question: "",
      },
    };
  },
  methods: {
    onClickSubmitForm() {
      const that = this;
      this.disabledSubmit = true;
      if (this.data && this.data.idx) {
        const params =
          "requesterIdx=" +
          this.form.requesterIdx +
          "&requestedIdx=" +
          this.data.idx +
          "&application=" +
          this.form.application +
          "&question=" +
          this.form.question;
        axios
          .post("/api/matching/nap/create?" + params)
          .then((response) => {
            if (response.status == 200) {
              that.onClose();
              that.handleToggleModal();
              that.$alert("알림", "제출해주셔서 감사합니다");
              // if (this.user.roleName == "ROLE_CORP") {
              //   this.$router.push("/crop/myMatchingStatusSent");
              // } else {
              //   this.$router.push("/user/myMatchingStatusSent");
              // }
            }
          })
          .catch((error) => {
            console.log("error : " + error);
            this.$alert("알림", "에러 발생됨");
            return [];
          })
          .finally(() => {
            that.disabledSubmit = false;
          });
      }
    },
    onClose() {
      this.form.application = "";
      this.form.question = "";
      this.handleToggleModal();
    },
  },
  watch: {
    isModal(val) {
      if (!val) this.form = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.itemRow {
  display: flex;
  align-items: flex-end;
  border: 1px solid #ababab;
  border-radius: 20px;
  padding: 3rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;

  .itemRowText {
    padding-left: 16px;
    height: 180px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
  }
}
</style>
